import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { obtenerCotizcionesMensualesAction } from "../../../ducks/reportesCotizacionesDuck"
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck"
import { makeStyles } from '@material-ui/core/styles'
import { Card, CardContent, Grid } from "@material-ui/core"
import { FormatoFecha } from "../../../utils/FormatFecha"
import GraficaBarras from "./Grafica"
import FiltroMes from "./FiltroMes"
const useStyles = makeStyles({
    main: {
        padding: "2%"
    },
    container: {
        display: "flex",
        flexFlow: "row",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "1rem",
    },
    root: {
        width: '60%',
        minWidth: 180,
        height: 460,
        marginTop: "1rem"
    },
    rootGrafica: {
        width: '40%',
        minWidth: 180,
        height: 460,
        marginTop: "1rem"
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 10,
        marginTop: 10,
        padding: 2
    },
})
const useReportes = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerCotizcionesMensualesAction({ Fecha: FormatoFecha({ date: new Date(), formato: "MMyyyy" }) })).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch])
}
const DEFAULT_COLOR_BG = 'rgba(75, 192, 192, 1)'
const COLOR_BG = {
    1: 'rgba(75, 192, 192, 0.2)',
    2: 'rgba(54, 162, 235, 0.2)',
    3: 'rgba(255, 206, 86, 0.2)',
    4: 'rgba(224, 176, 255, 0.2)',
    5: 'rgba(153, 102, 255, 0.2)',
    6: 'rgba(255, 99, 132, 0.2)',
    7: 'rgba(17,212,82,0.2)',
    8: 'rgba(255, 236, 227, 0.2)',
    9: 'rgba(222, 255, 160, 0.2)',
    10: 'rgba(255, 125, 125, 0.2)',
    11: 'rgba(249, 224, 224, 0.2)',
}
const DEFAULT_COLOR_BG_BORDER = 'rgba(75, 192, 192, 1)'
const COLOR_BG_BORDER = {
    1: 'rgba(75, 192, 192, 1)',
    2: 'rgba(54, 162, 235, 1)',
    3: 'rgba(255, 206, 86, 1)',
    4: 'rgba(224,176,255, 1)',
    5: 'rgba(153, 102, 255, 1)',
    6: 'rgba(255, 99, 132, 1)',
    7: 'rgba(17,212,82,1)',
    8: 'rgba(255,236,227,1)',
    9: 'rgba(222,255,160,1)',
    10: 'rgba(255,125,125,1)',
    11: 'rgba(249, 224, 224, 1)',
}
const useDataGraficarGenralMes = () => {
    const { cotizacionesAllMes, fechaMes } = useSelector(store => store.reporteCotizador)
    const copyDetalleCotizacionGlobal = cotizacionesAllMes?.lDetalleCotizacionGlobal ?? []
    const labels = [`${FormatoFecha({ date: fechaMes, formato: "MM/yyyy" })}`]
    const arrayData = copyDetalleCotizacionGlobal.map((cotizacion, index) => {
        return {
            label: `${cotizacion?.catEstatusCotizacion?.Descripcion}`,
            data: [cotizacion?.total],
            backgroundColor: COLOR_BG[cotizacion?.catEstatusCotizacion?.IdCatEstatusCotizacion] || DEFAULT_COLOR_BG,
            borderColor: COLOR_BG_BORDER[cotizacion?.catEstatusCotizacion?.IdCatEstatusCotizacion] || DEFAULT_COLOR_BG_BORDER
        }
    })
    let data = {
        labels,
        datasets: arrayData
    }
    return data
}
const dataGraficarGenralMes = ({ cotizacionesAgente, fecha }) => {
    const copyDetalleCotizacion = cotizacionesAgente ?? []
    const arrayOrdenado = copyDetalleCotizacion.sort((a, b) => {
        return a.catEstatusCotizacion?.IdCatEstatusCotizacion - b.catEstatusCotizacion?.IdCatEstatusCotizacion
    })
    const labels = [`${FormatoFecha({ date: fecha, formato: "MM/yyyy" })}`]
    const arrayData = arrayOrdenado.map((cotizacion, index) => {
        return {
            label: `${cotizacion?.catEstatusCotizacion?.Descripcion}`,
            data: [cotizacion?.total],
            backgroundColor: COLOR_BG[cotizacion?.catEstatusCotizacion?.IdCatEstatusCotizacion] || DEFAULT_COLOR_BG,
            borderColor: COLOR_BG_BORDER[cotizacion?.catEstatusCotizacion?.IdCatEstatusCotizacion] || DEFAULT_COLOR_BG_BORDER
        }
    })
    let data = {
        labels,
        datasets: arrayData
    }
    return data
}
const CotizacionesMes = () => {
    const classes = useStyles()
    const { cotizacionesAllMes, fechaMes } = useSelector(store => store.reporteCotizador)
    useReportes()
    const data = useDataGraficarGenralMes()
    return (
        <>
            <Grid container style={{ margin: "1rem 0" }} alignItems="center" justifyContent="center" spacing={1}>
                <Grid item xs={4}>
                    <FiltroMes />
                </Grid>
            </Grid>
            <Grid container style={{ margin: "1rem 0" }} alignItems="center" justifyContent="center" spacing={1}>
                <Grid item xs={6}>
                    <Card>
                        <CardContent>
                            <h3>Datos genrales</h3>
                            Total de cotizaciones del mes: {cotizacionesAllMes?.total}
                            {
                                cotizacionesAllMes?.lDetalleCotizacionGlobal?.sort((a, b) => {
                                    return a.catEstatusCotizacion?.IdCatEstatusCotizacion - b.catEstatusCotizacion?.IdCatEstatusCotizacion
                                })?.map((cotizacion, index) => {
                                    return (
                                        <div key={index}>
                                            {`${cotizacion?.catEstatusCotizacion?.Descripcion}: ${cotizacion?.total}`}
                                        </div>
                                    )
                                })
                            }

                            <GraficaBarras data={data} />
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            <Grid container style={{ marginBottom: "1rem" }} alignItems="flex-start" justifyContent="center" spacing={1}>
                {
                    cotizacionesAllMes?.lCuentaCotizacion?.map(item => {
                        return (
                            <Grid item xs={4} key={item.cuenta?.Id_Cuenta}>
                                <Card style={{ minHeight: "430px" }}>
                                    <CardContent>
                                        <b>Agente:</b>
                                        {
                                            ` ${item.cuenta?.Nombre} ${item.cuenta?.Apellido_Paterno} ${item.cuenta?.Apellido_Materno}`
                                        }
                                        <br />
                                        {
                                            `${item.cuenta?.eMail}`

                                        }
                                        <br />
                                        Total de cotizacion del agente: {item.lDetalleCotizacion?.reduce((a, b) => a + b.total, 0)}
                                        <br />
                                        {
                                            item.lDetalleCotizacion?.sort((a, b) => {
                                                return a.catEstatusCotizacion?.IdCatEstatusCotizacion - b.catEstatusCotizacion?.IdCatEstatusCotizacion
                                            }).map(cotizacion => {
                                                return (
                                                    <div key={cotizacion?.catEstatusCotizacion?.IdCatEstatusCotizacion}>
                                                        {`${cotizacion?.catEstatusCotizacion?.Descripcion}: ${cotizacion?.total}`}
                                                    </div>
                                                )
                                            })
                                        }
                                        <GraficaBarras data={dataGraficarGenralMes({ cotizacionesAgente: item.lDetalleCotizacion, fecha: fechaMes })} />
                                    </CardContent>
                                </Card>
                            </Grid>
                        )
                    })
                }
            </Grid>
        </>
    )
}
export default CotizacionesMes